import React, { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import "./CustomerSearch.scss";
import { Link } from "react-router-dom";
import BackArrow from "src/atoms/backArrow/backArrow";
import { useLocation } from 'react-router-dom';
import { getDateFormat, getPaymentAmout } from "src/utils/utils";

import StarIcon from '../../assets/testRide/starIcon.png'

let paymentTypeList = [
  { key: "NEW", value: "No information is available"},
  { key: "PRE_ORDERED", value: "Reserved scooter"},
  { key: "PURCHASED", value: "Advance Payment done"},
  { key: "ORDERED", value: "Balance payment or full payment or down payment done"},
  { key: "DOCUMENTS_UPLOADED", value: "Document uploaded"},
  { key: "DOCUMENTS_VERIFIED", value: "Document verified"},
  { Key: "DISPATCHED", value: "Scooter dispatched from factory"},
  { key: "REACHED_SDC", value: "Scooter reached SDC"},
  { key: "LOAN_DETAILS_TABLE", value: "To check if loan has been disbursed (possible states - created, inititated, accepted, disbursement inittiated, disbursed)"},
  { key: "REGISTERED", value: "Registration done"},
  { key: "DELIVERED", value: "Scooter delivered"}
];

const CustomerDetails = () => {
    const location = useLocation();
    const {order_detail, tr_history, user_detail, customer_visit_details } = location?.state ? location?.state?.customerData : {}

  const getPaymentType = (Ptype) => {
    let typeValue = paymentTypeList?.find(item => {
        if(item?.key === Ptype){
          return item?.value
        }
  });
   return typeValue?.value;
  }

  return (
    <div className="customer-search-main-container">
      <div className="right-container customer-details">
      <div className="cs-form-controls">
          <Link to="/customer-search">
            <BackArrow removeClass={true}/>
          </Link>
          <div style={{paddingLeft: "20px"}} className="label">Ola Champion Lead Status</div>
        </div>
        <div className="">
          <div className="customer-container">
            <div className="cs-form-container">
              <div className="acco-topograph">
                <p className="customer-label">Customer Name</p>
                <p className="customer-detail-txt">{user_detail?.name}</p>
              </div>
              {false && <div className="acco-topograph">
                <p className="customer-label">Customer Score</p>
                <div className="customer-score-container">
                  <img style={{objectFit: "contain"}} src={StarIcon} alt="star-icon"/>
                  <p className="customer-detail-txt">Gold</p>
                </div>
                <p className="customer-label customer-label-gold ">Customer is a regular user of Ola services and has a high probability of conversion</p>
              </div> }
              <div className="accordion-container acco-topograph">
                <div className="customer-label">Scooter Purchase History</div>
                {order_detail?.user_orders?.length > 0 ? order_detail?.user_orders?.map((order, i) => (
                  <div key={i} style={{ paddingTop: "20px" }}>
                    <Accordion
                      classes={{
                        root: "lowercase text-gray-500 bg-red-100",
                      }}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography>
                            <div className={order?.status !== "DELIVERED" ? "customer-detail-txt status-txt" : "customer-label"}>{order?.status}</div>
                          <div className="customer-detail-txt">
                            {order?.order_metadata?.name} - {order?.order_metadata?.color}
                          </div>
                          <div className="customer-label">
                            Reserved on {getDateFormat(order?.created)}
                          </div>
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails> 
                      <Typography>
                          <div>
                            <div className="acco-topograph">
                              <p className="customer-label">Order ID</p>
                              <p className="customer-detail-txt">{order?.order_id}</p>
                            </div>
                            <div className="acco-topograph">
                              <p className="customer-label">Payment Type</p>
                              <p className="customer-detail-txt">{order?.status ? getPaymentType(order?.status) : "-"}</p>
                            </div>
                            <div className="acco-topograph">
                              <p className="customer-label">Payment Date</p>
                              <p disabled className="customer-detail-txt txt-area">{order?.created ? getDateFormat(order?.created): "-"}</p>
                            </div>
                            <div className="acco-topograph">
                              <p className="customer-label">Payment Amount</p>
                              <p className="customer-detail-txt">{(order?.payment_details_dto_list?.length > 0) ? getPaymentAmout(order?.payment_details_dto_list[order?.payment_details_dto_list?.length-1].amount) : "-"}</p>
                            </div>
                          </div>
                        </Typography>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                )): <div style={{paddingTop: "10px"}}> <Accordion>
                <AccordionSummary>
                  <Typography>
                    <div className="customer-detail-txt">
                      No Purchases Made
                    </div>
                  </Typography>
                </AccordionSummary>
                </Accordion> 
                </div>}
              </div>
              <div className="accordion-container acco-topograph">
                <div className="customer-label">Test ride History</div>
                {tr_history?.test_ride_response_list?.length > 0 ? tr_history?.test_ride_response_list?.map((trData, i) => (
                  <div key={i} style={{ paddingTop: "20px" }}>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography>
                          <div className="customer-detail-txt">{getDateFormat(trData?.start_time)}</div>
                          <div className="customer-label">
                            Test ride at home
                          </div>
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography>
                          <div>
                            <div className="acco-topograph">
                              <p className="customer-label">Status</p>
                              <p className="customer-detail-txt">{trData?.status}</p>
                            </div>
                            <div className="acco-topograph">
                              <p className="customer-label">Customer rating</p>
                              <p className="customer-detail-txt">{trData?.rating}</p>
                            </div>
                            <div className="acco-topograph">
                              <p className="customer-label">Feedback</p>
                              <p disabled className="customer-detail-txt txt-area">{trData?.user_comments ? trData?.user_comments: "-"}</p>
                            </div>
                            <div className="acco-topograph">
                              <p className="customer-label">Brand Champion Name</p>
                              <p className="customer-detail-txt">{trData?.branch_champion_detail?.first_name} {trData?.branch_champion_detail?.last_name}</p>
                            </div>
                          </div>
                        </Typography>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                )) : <div style={{paddingTop: "10px"}}><Accordion>
                <AccordionSummary>
                  <Typography>
                    <div className="customer-detail-txt">
                        No test rides taken
                    </div>
                  </Typography>
                </AccordionSummary>
                </Accordion>
                </div>}
              </div>
              <div className="accordion-container acco-topograph">
                <div className="customer-label">Experience Center Visit</div>
                {customer_visit_details?.length > 0 ? customer_visit_details?.map((visitData, i) => (<div key={i} style={{ paddingTop: "20px" }}>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography>
                          <div className="customer-detail-txt">{customer_visit_details[0]?.experienceCenter}</div>
                          <div className="customer-label">
                            {getDateFormat(customer_visit_details[0]?.createdAt)}
                          </div>
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography>
                          <div>
                            <div className="acco-topograph">
                              <p className="customer-label">City</p>
                              <p className="customer-detail-txt">{visitData?.city ? visitData?.city : "-"}</p>
                            </div>
                            <div className="acco-topograph">
                              <p className="customer-label">Name</p>
                              <p className="customer-detail-txt">{visitData?.name ? visitData?.name : "-"}</p>
                            </div>
                            <div className="acco-topograph">
                              <p className="customer-label">Lead Visit</p>
                              <p disabled className="customer-detail-txt txt-area">{visitData?.leadStage ? visitData?.leadStage : "-"}</p>
                            </div>
                          </div>
                        </Typography>
                      </AccordionDetails>
                    </Accordion>
                  </div>))
                : <div style={{paddingTop: "10px"}}><Accordion>
                <AccordionSummary>
                  <Typography>
                    <div className="customer-detail-txt">
                        No excperience center visits found
                    </div>
                  </Typography>
                </AccordionSummary>
                </Accordion>
                </div>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerDetails;
